import { render, staticRenderFns } from "./MbConfirm.vue?vue&type=template&id=7ad20243&"
import script from "./MbConfirm.vue?vue&type=script&lang=js&"
export * from "./MbConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports